import React from 'react';
import { FaUserAlt } from 'react-icons/fa';
import styled from 'styled-components';

const PlaceholderContainer = styled.div`
  width: 100%;
  height: 500px;
  display: flex;
  background-color: #a9a9a9;
  justify-content: center;
`;

const Placeholder = () => (
  <PlaceholderContainer>
    <FaUserAlt color="#c9c9c9" fontSize={200} style={{ alignSelf: 'center' }} />
  </PlaceholderContainer>
);

export default Placeholder;
